import { ThunkResult } from '../../store'
import shipOrderApi from '../../apis/shipOrder.api'
import shipOrderService from '../../services/shipOrder.service'
import { replaceResult, replaceResultData } from './ShipOrders.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().shipOrders
    const params = { page, limit, search }
    shipOrderApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteShipOrder (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    shipOrderApi.delete(id, shipOrder => {
      if (!shipOrder) return
      const { result } = getState().shipOrders
      const data = shipOrderService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
